module.exports = __webpack_public_path__ + "img/downloading.58087e07.gif";